<template lang="jade">
  .container-fluid
    .row
      .setting_main.col-md-12(v-if="!loadingData")
        header.setting_title_bar.main_title_bar.clearfix
          h1.title.col-md-10.col-sm-10.col-xs-12
            | installer list
        section.list_section.col-md-12
          .col-xs-12.title_group
            label Installer:
            label.pull-right Total: {{dbInstaller.length}}
          .col-xs-12.col-md-12
            table.table.table-striped.table-bordered
              thead
                tr
                  th.text-center No.
                  th.text-center Email
                  th.text-center Installer ID
                  th
              tbody

                tr(v-for="(idx, installer) in sortedInstaller")
                  td.text-center {{idx+1}}
                  td.text-center {{installer.email}}
                  td.text-center {{installer.installerCode}}
                  td.text-center
                    span(v-if="installer.email !== 'evoipservice@gmail.com'")
                      i.fa.fa-edit


        modal.confirm_modal(
          title="Confirm"
          v-bind:show.sync= "showConfirm"
          effect= "zoom"
          v-bind:callback='confirmCb'
          ok-text="Yes"
          cancel-text="Cancel")
            .modal-body(slot='modal-body').clearfix {{ confirmMsg }}

</template>
<script>
import { modal } from 'vue-strap'
import { getInstallerRef } from '../../Service.js'

export default {
  components: {
    modal
  },
  data: () => {
    return {
      showInstallerList: false
    }
  },
  firebase () {
    return {
      dbInstaller: {
        source: getInstallerRef(),
        asArray: true
      }
    }
  },
  asyncData () {

  },
  computed: {
    sortedInstaller () {
      let mailAry = JSON.parse(JSON.stringify(this.dbInstaller))
      if (mailAry.length === 0) return []
      mailAry.sort((a, b) => {
        return a.email > b.email
      })

      let start = []
      let end = []
      for (let idx in mailAry) {
        if (mailAry[idx].email === 'evoipservice@gmail.com') {
          start = mailAry.slice(0, idx)
          end = mailAry.slice(idx)
          break
        }
      }
      start.unshift(end.shift())
      return start.concat(end)
    }
  },
  ready () {
    console.log('installer list')
  },
  events: {
    user (uid, user) {
      this.isInstaller = user.installer
    }
  },
  methods: {
    alert (type, title, content) {
      this.$dispatch('alert', {
        type: type,
        title: title,
        content: content
      })
    }
  } // close methods
}
</script>

<style lang='scss' scoped>
  @import '~__vendor_variables_scss__';
  @import '~sass/_breakpoint.scss';
  .list_section {
    max-width: 1000px;
    margin-right: auto;
    margin-left: auto;
    float: none;
    padding-top: 30px;
  }
  .title_group label {
    font-weight: bold;
    font-size: 20px;
  }
</style>



// WEBPACK FOOTER //
// installerList.vue?ee06b2b2